/**
 * @desc Deep-link preservation across the AuthKit redirect roundtrip. The `returnTo` carried in
 * the OAuth `state` is delivered to `onRedirectCallback`, which fires around the code exchange —
 * racing router mount and the initial '/' load, so an imperative `router.navigate` there is
 * unreliable (observed: reloads of a deep link landing on the Dashboard). The callback instead
 * parks the path here (sessionStorage: per-tab, survives the redirect navigation chain) and the
 * protected layout consumes it exactly once after auth has settled and the router is live.
 *
 * sessionStorage can throw (blocked site data); every access fails soft — worst case the user
 * lands on '/' as before.
 */
const KEY = 'h2gc-return-to';

export function setPendingReturnTo(path: string): void {
  try {
    sessionStorage.setItem(KEY, path);
  } catch {
    // Blocked storage: the fast-path navigate may still win; otherwise the user lands on '/'.
  }
}

export function consumePendingReturnTo(): string | null {
  try {
    const value = sessionStorage.getItem(KEY);
    if (value !== null) sessionStorage.removeItem(KEY);
    return value;
  } catch {
    return null;
  }
}
